// extracted by mini-css-extract-plugin
export default {"cell":"cell-R5dBR","item":"item-ikIvC","smallLabel":"smallLabel-mJigK"};